module.exports = __webpack_public_path__ + "static/small_start-530feb65203af16d5fd6918aaf358c1c.jpg";